<template>
    <footer class="footer section">
        <div class="container">
            <div class="footer-content">
                <div class="row align-items-start">
                    <div class="col-md-5">
                        <div class="about">
                            <img :src="websiteStore?.initializationData?.website_settings?.footer_logo" alt="logo" draggable="false" class="default">
                            <!-- <img src="/website/assets/img/review-logo-white.png" alt="logo" draggable="false" class="default"> -->

                            <p v-if="websiteStore?.initializationData?.about_us">
                               {{websiteStore?.initializationData?.about_us}}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-2 offset-md-1">
                        <div class="links">
                            <h3>روابط</h3>
                            <ul>
                                <li><NuxtLink :to="`/about-us`">من نحن</NuxtLink></li>
                                <li><NuxtLink :to="`/terms`"> الشروط والأحكام </NuxtLink></li>
                                <li><NuxtLink :to="`/privacy`"> سياسة الخصوصية</NuxtLink></li>
                                <li v-if="!isAuthenticated">
                                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#userModal">اقترح</a>
                                    </li>
                                <li v-if="isAuthenticated">
                                    <NuxtLink :to="`/suggest`">اقترح</NuxtLink>
                                </li>
                                <li><a href="https://blog.reviewapp.sa/" target="_blank">المدونة</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="links">
                            <h3>أخرى</h3>
                            <ul>
                                <li><NuxtLink :to="`/business`">للأعمال</NuxtLink></li>
                                <li><NuxtLink :to="`/experts`">برنامج الخبراء</NuxtLink></li>
                                <li><NuxtLink :to="`/contact-us`">تواصل معنا</NuxtLink></li>
                                <li v-if="!isAuthenticated"><a href="javascript:void(0)" data-bs-toggle="modal"
                                        data-bs-target="#userModal">تسجيل الدخول</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-2 social-col">
                        <div class="social">
                            <h3>تابعنا</h3>
                            <ul>
                                <li v-if="websiteStore?.initializationData?.x"><a :href="websiteStore?.initializationData?.x" target="_blank"><i
                                            class="icon-twitter-x"></i></a></li>
                                <li v-if="websiteStore?.initializationData?.instagram"><a :href="websiteStore?.initializationData?.instagram" target="_blank"><i
                                            class="bx bxl-instagram-alt"></i></a></li>
                                <li v-if="websiteStore?.initializationData?.tiktok"><a :href="websiteStore?.initializationData?.tiktok" target="_blank"><i
                                            class="bx bxl-tiktok"></i></a></li>
                                <li v-if="websiteStore?.initializationData?.youtube"><a :href="websiteStore?.initializationData?.youtube" target="_blank"><i
                                            class="bx bxl-youtube"></i></a></li>
                                <li v-if="websiteStore?.initializationData?.snapchat"><a :href="websiteStore?.initializationData?.snapchat" target="_blank"><i
                                            class="bx bxl-snapchat"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 social-col offset-md-6">
                        <div class="footer-apps">
                            <p>
                                حمل تطبيق رفيو الآن و تمتع بتجربة  فريدة
                            </p>
                           <div class="apps-links">
                                <a href="https://apps.apple.com/us/app/review-%D8%B1%D9%81%D9%8A%D9%88/id6742455576" target="_blank">
                                    <img src="/website/assets/img/apps/app-store-w-download.svg" alt="app-store">
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.reviewapp.sa" target="_blank">
                                    <img src="/website/assets/img/apps/google-play-w-download.svg" alt="google-play">
                                </a>
                           </div>
                        </div>
                    </div>
                </div>
                
            </div>
           
            <div class="footer-copyrights">
                <div class="copyrights">
                    <p>
                        جميع الحقوق محفوظة لــ {{websiteStore.websiteName}} © {{ currentYear }}
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
 
    import { useWebsiteStore } from '~/store/website'
    import { useAuthStore } from "@/store/auth";
    const authStore = useAuthStore();
    const isAuthenticated = computed(() => authStore.isAuthenticated);
    const websiteStore = useWebsiteStore()
    const currentYear = new Date().getFullYear();

    
</script>
